import React, { useState, useEffect, useMemo } from 'react';
import { KTSVG } from '../../../../../_mexablock/helpers';
import { useFormik } from 'formik';
import { getAllSelectRol, getAllUsers } from '../../../../service/reportes/AccountStatment';
import Select from 'react-select';
import { FilterMov } from '../../activaciones/_modals/FilterDate';

type Props = {
  initFilterValues: any;
  onCleanFilter: () => void;
  onSearchFilter: (values: any) => void;
  showFilterCode: boolean;
  userRoles?: any[];
};

const Filter: React.FC<Props> = ({
  initFilterValues,
  onSearchFilter,
  onCleanFilter,
  showFilterCode,
  userRoles = [],
}) => {
  const [filterValues, setFilterValues] = useState(initFilterValues);
  const [selectedUsuario, setSelectedUsuario] = useState<any>(null);
  const [changeName, setChangeName] = useState(false);
  const [rolOptions, setRolOptions] = useState<any[]>([]);
  const [usersOptions, setUsersOptions] = useState<any[]>([]);
  const [loadingUsers, setLoadingUsers] = useState(false);

  useEffect(() => {
    getAllSelectRol()
      .then((res) => setRolOptions(res))
      .catch((err) => console.log('Error al obtener roles', err));
  }, []);

  const formFilter = useFormik({
    initialValues: filterValues,
    enableReinitialize: true,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      onSearchFilter({ ...values, filter: 1 });
    },
  });

  const selectedRol = useMemo(
    () => rolOptions.find((o) => o.value === formFilter.values.rol_id) || null,
    [rolOptions, formFilter.values.rol_id]
  );

  const shouldShowFilters = useMemo(() => {
    if (!showFilterCode || !userRoles?.length) return false;

    const restrictedRoles = ['DISTRIBUTOR', 'ADMIN_COMPANY'];
    const hasRestrictedRole = userRoles.some((role: any) =>
      restrictedRoles.includes(role.code),
    );

    return !hasRestrictedRole;
  }, [showFilterCode, userRoles]);

 


  useEffect(() => {
    if (selectedRol?.value && selectedRol.value !== 'distributor') {
      const fetchUsers = async () => {
        setLoadingUsers(true);
        try {
          const response = await getAllUsers(selectedRol.value);
          const mappedUsers = response.map((user: any) => {
            const fullName = `${user.first_name || ''} ${user.father_last_name || ''} ${user.mother_last_name || ''}`
              .replace(/\s+/g, ' ')
              .trim();
            return {
              ...user,
              value: user.id,
              label: fullName || 'Sin nombre',
            };
          });
          setUsersOptions(mappedUsers);
        } catch (error) {
          console.error('Error al obtener usuarios', error);
          setUsersOptions([]);
        } finally {
          setLoadingUsers(false);
        }
      };
      fetchUsers();
    } else {
      setUsersOptions([]);
    }
  }, [selectedRol]);

  useEffect(() => {
    if (initFilterValues) {
      setFilterValues(initFilterValues);
    }
  }, [initFilterValues]);

  return (
    <>
      <div className="card-title align-items-start flex-column">
        <a
          href="#/"
          className={
            formFilter.values.filter !== 0
              ? ' btn btn-sm btn-primary'
              : 'btn btn-sm btn-light-primary'
          }
          data-kt-menu-trigger="click"
          data-kt-menu-placement="right-start"
        >
          <KTSVG
            path="/media/icons/duotune/general/gen031.svg"
            className="svg-icon-5 svg-icon-gray-500 me-1"
          />
          Filtrar
        </a>
        <div
          className="menu menu-sub menu-sub-dropdown w-300px w-md-300px ms-2"
          data-kt-menu="true"
        >
          <div className="px-7 py-5">
            <div className="fs-5 text-dark fw-bolder">Opciones de filtro</div>
          </div>

          <div className="separator border-gray-200"></div>
          <form
            id="kt_modal_generic_form"
            className="form"
            action="#"
            onSubmit={formFilter.handleSubmit}
          >
            <div className="px-7 py-5">
             {shouldShowFilters ? (
              <>
                  <div className="mb-5" onClick={(e) => e.stopPropagation()}>
                    <label className="form-label fw-bold">Tipo:</label>
                    <Select
                      options={rolOptions}
                      styles={{
                        placeholder: (provided) => ({
                          ...provided,
                          color: '#181c32',
                        }),
                        indicatorSeparator: (provided) => ({
                          ...provided,
                          display: 'none',
                        }),
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          color: '#7E8199',
                        }),
                        control: (provided, state) => ({
                          ...provided,
                          border: '1px solid #e4e6ef',
                          borderRadius: '6px',
                          padding: '3px',
                          fontSize: '1.1rem',
                          boxShadow: 'none',
                          backgroundColor: state.isDisabled
                            ? '#EFF2F5'
                            : 'white',
                        }),
                        option: (provided) => ({
                          ...provided,
                          fontSize: '1.1rem',
                        }),
                        menuPortal: (provided) => ({
                          ...provided,
                          zIndex: 9999,
                        }),
                      }}
                      menuPortalTarget={document.body}
                      menuPosition="fixed"
                      placeholder="Seleccione un tipo"
                      isSearchable={false}
                      isClearable={true}
                      noOptionsMessage={() => 'No hay registros'}
                      onChange={(option: any) => {
                        formFilter.setFieldValue('rol_id', option?.value || '');
                        setSelectedUsuario(null);
                        formFilter.setFieldValue('user_id', '');
                        setUsersOptions([]);
                      }}
                      value={selectedRol}
                      closeMenuOnSelect={true}
                    />
                  </div>
              </>
             ) : null
             }
                  {selectedRol && (
                    <div className="mb-5" onClick={(e) => e.stopPropagation()}>
                      <label className="form-label fw-bold">Usuario:</label>
                      <Select
                        isLoading={loadingUsers}
                        options={
                          usersOptions
                        }
                        styles={{
                          placeholder: (provided) => ({
                            ...provided,
                            color: '#181c32',
                          }),
                          indicatorSeparator: (provided) => ({
                            ...provided,
                            display: 'none',
                          }),
                          dropdownIndicator: (provided) => ({
                            ...provided,
                            color: '#7E8199',
                          }),
                          control: (provided, state) => ({
                            ...provided,
                            border: '1px solid #e4e6ef',
                            borderRadius: '6px',
                            padding: '3px',
                            fontSize: '1.1rem',
                            boxShadow: 'none',
                            backgroundColor: state.isDisabled
                              ? '#EFF2F5'
                              : 'white',
                          }),
                          option: (provided) => ({
                            ...provided,
                            fontSize: '1.1rem',
                          }),
                          menuPortal: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                        }}
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        placeholder="Selecciona usuario"
                        noOptionsMessage={() => 'No se encontraron registros'}
                        onChange={(option: any) => {
                          setSelectedUsuario(option);
                          formFilter.setFieldValue('user_id', option?.id || option?.value);
                        }}
                        value={selectedUsuario}
                        closeMenuOnSelect={true}
                      />
                    </div>
                  )}
             
              <div className="mb-5">
                <FilterMov
                  valueInit={formFilter.values.init_date}
                  valueEnd={formFilter.values.end_date}
                  setInitDate={(date: string) => {
                    formFilter.setFieldValue('init_date', date);
                    setChangeName(false);
                  }}
                  setEndDate={(date: string) => {
                    formFilter.setFieldValue('end_date', date);
                    setChangeName(false);
                  }}
                  onCleanFilter={() => {
                    formFilter.setFieldValue('init_date', '');
                    formFilter.setFieldValue('end_date', '');
                    setChangeName(true);
                  }}
                  changeName={changeName}
                />
              </div>
              <div className="d-flex justify-content-end">
                <button
                  type="reset"
                  className="btn btn-sm btn-white btn-active-light-primary me-2"
                  data-kt-menu-dismiss="true"
                  onClick={() => {
                    formFilter.resetForm();
                    setSelectedUsuario(null);
                    setUsersOptions([]);
                    onCleanFilter();
                  }}
                >
                  Limpiar
                </button>

                <button
                  type="submit"
                  className="btn btn-sm btn-primary"
                  data-kt-menu-dismiss="true"
                >
                  Buscar
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export { Filter };
